'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function FerriesError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { page: 'ferries' },
    });
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-gray-50">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold mb-4">Oops! Ferry search encountered an issue</h2>
        <p className="text-gray-600 mb-6">
          Don't worry, we've logged the error and will fix it soon. Try refreshing the page.
        </p>
        <button
          onClick={reset}
          className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}
